import { Link } from 'react-router';
import PropertyCard from '../../components/PropertyCard.jsx';
import { EmptyState, ErrorState, Spinner } from '../../components/ui.jsx';
import { useFavoriteToggle, useFetch, useTitle } from '../../lib/hooks.js';
import { formatXaf, pluralise, timeAgo } from '../../lib/format.js';

const SavedListings = () => {
  useTitle('Saved houses');
  const { data, loading, error, reload, setData } = useFetch('/favorites');

  // Removing a saved listing takes it straight out of the list, since a card with
  // an empty heart sitting in the saved page would just be confusing.
  const onFavorite = useFavoriteToggle((id) => {
    setData({ items: (data?.items || []).filter((item) => item.id !== id) });
  });

  if (loading && !data) return <Spinner />;
  if (error) {
    return (
      <div className="container section">
        <ErrorState message={error} onRetry={reload} />
      </div>
    );
  }

  const items = data.items || [];
  const total = items.reduce((sum, item) => sum + item.price, 0);

  return (
    <div className="container section">
      <header className="page-head">
        <div>
          <h1>Saved houses</h1>
          <p className="muted">
            {items.length > 0
              ? `${pluralise(items.length, 'house')} saved, averaging ${formatXaf(Math.round(total / items.length))} a month.`
              : 'Nothing saved yet.'}
          </p>
        </div>
        <Link to="/search" className="btn btn-outline">
          Keep looking
        </Link>
      </header>

      {items.length === 0 ? (
        <EmptyState
          title="Your list is empty"
          message="Tap the heart on any listing and it lands here, so you can compare a few houses before you commit to a viewing."
          action={
            <Link to="/search" className="btn btn-primary">
              Browse listings
            </Link>
          }
        />
      ) : (
        <div className="card-grid">
          {items.map((property) => (
            <PropertyCard
              key={property.id}
              property={property}
              onToggleFavorite={onFavorite}
              footer={<p className="card-footnote">Saved {timeAgo(property.savedAt)}</p>}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SavedListings;
